import { Stack } from '@fluentui/react';
import React from 'react';

import { Notification } from './Notification';
import { INotificationsProps } from './Notifications.model';

export const Notifications = (props: INotificationsProps): JSX.Element => {
  if (!props.notifications) {
    return null;
  }
  return (
    <Stack tokens={{ childrenGap: 10 }}>
      {props.notifications
        .filter(notification => !notification.isDismissed)
        .map(notification => (
          <Notification {...props} key={notification.id} notification={notification} />
        ))}
    </Stack>
  );
};
